// extracted by mini-css-extract-plugin
module.exports = {"container":"e3afc254ff--container--tIU3H","name":"e3afc254ff--name--e4XPX","info":"e3afc254ff--info--T_pLb","stars":"e3afc254ff--stars--xqYCS"};